import * as React from 'react';
import './collapse.scss';

interface ICollapseProps {
    title: string | React.ReactNode;
    showChildrenByDefault?: boolean;
}

interface ICollapseState {
    showChildren: boolean;
}

export class Collapse extends React.PureComponent<ICollapseProps, ICollapseState> {
    constructor(props: ICollapseProps) {
        super(props);

        this.state = { showChildren: !!props.showChildrenByDefault };
        this.toggleShowChildren = this.toggleShowChildren.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div className="collapse">
                {this.renderHeader()}
                {this.renderChildren()}
            </div>
        );
    }

    private renderHeader(): React.ReactNode {
        const collapseIconClasses = this.state.showChildren ? 'icon-up-open' : 'icon-down-open';
        return (
            <button
                onClick={this.toggleShowChildren}
                className="pxl-box collapse__header"
            >
                <div className="collapse__trigger pxl-link">
                    <i className={collapseIconClasses} />
                </div>
                {this.props.title}
            </button>
        );
    }

    private renderChildren(): React.ReactNode {
        if (!this.state.showChildren) {
            return null;
        }
        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        );
    }

    private toggleShowChildren(): void {
        this.setState({ showChildren: !this.state.showChildren });
    }
}

export default Collapse;